export var buttonBorderRadiusStyle = "\n  border-radius: 4px;\n";